import { useEffect, useState } from 'react';
import TopNav from '@/pages/home/components/TopNav';
import CoverHero from '@/pages/home/components/CoverHero';
import TodayStories from '@/pages/home/components/TodayStories';
import LatestLicks from '@/pages/home/components/LatestLicks';
import PeopleInsider from '@/pages/home/components/PeopleInsider';
import HotTalk from '@/pages/home/components/HotTalk';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 700);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <TopNav />
      <main>
        <CoverHero />
        <TodayStories />
        <LatestLicks />
        <PeopleInsider />
        <HotTalk />
      </main>
      <SiteFooter />

      {showTop ? (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-background-300/70 bg-background-50/95 text-foreground-700 backdrop-blur transition-colors hover:border-primary-300 hover:text-primary-600 md:right-10"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      ) : null}
    </div>
  );
}